import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "type", "error", "label", "hint", "LabelProps", "InputProps", "inputProps", "inputRef", "TextareaProps", "readOnly", "disabled", "size", "value"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PT from 'prop-types';
import { intrinsicComponent, objectValues } from '../../utils/functions';
import Label from '../label';
import { propTypes as labelPropTypes } from '../label/label.component';
import Input from '../input';
import { propTypes as inputPropTypes } from '../input/input.component';
import { InputSize } from '../../utils/types';
import Textarea from '../textarea';
import { propTypes as textareaPropTypes } from '../textarea/textarea.component';
import FormHint from '../form-hint';
import { Type } from './types';
import Styled from './input-group.styles';
var InputGroup = intrinsicComponent(function (_ref, ref) {
  var children = _ref.children,
    type = _ref.type,
    error = _ref.error,
    label = _ref.label,
    hint = _ref.hint,
    LabelPropsData = _ref.LabelProps,
    InputPropsData = _ref.InputProps,
    inputProps = _ref.inputProps,
    inputRef = _ref.inputRef,
    TextareaPropsData = _ref.TextareaProps,
    readOnly = _ref.readOnly,
    disabled = _ref.disabled,
    size = _ref.size,
    value = _ref.value,
    rest = _objectWithoutProperties(_ref, _excluded);
  var renderLabel = function renderLabel() {
    if (label) {
      if (typeof label === 'function') {
        return label({
          error: error
        });
      }
      if (_typeof(label) === 'object') {
        return label;
      }
      return /*#__PURE__*/React.createElement(Label, _extends({
        size: size,
        error: error,
        disabled: disabled
      }, LabelPropsData || {}), label);
    }
    return null;
  };
  var renderField = function renderField() {
    var fieldProps = _objectSpread({
      value: value,
      readOnly: readOnly,
      disabled: disabled,
      size: size,
      error: error
    }, rest);
    if (type === Type.Input) {
      return /*#__PURE__*/React.createElement(Input, _extends({}, fieldProps, InputPropsData || {}, inputProps, {
        ref: (inputRef === null || inputRef === void 0 ? void 0 : inputRef.ref) || inputRef,
        readOnly: readOnly,
        disabled: disabled
      }));
    }
    if (type === Type.Textarea) {
      return /*#__PURE__*/React.createElement(Textarea, _extends({}, fieldProps, TextareaPropsData || {}));
    }
    return null;
  };
  var renderHint = function renderHint() {
    if (hint) {
      if (typeof hint === 'function') {
        return hint({
          error: error
        });
      }
      if (_typeof(hint) === 'object') {
        return hint;
      }
      return /*#__PURE__*/React.createElement(FormHint, {
        size: size,
        error: error,
        disabled: disabled
      }, hint);
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(Styled.InputGroup, {
    ref: ref
  }, renderLabel(), renderField(), renderHint());
});
InputGroup.defaultProps = {
  type: Type.Input,
  error: false,
  readOnly: false
};
InputGroup.propTypes = {
  type: PT.oneOf(objectValues(Type)),
  size: PT.oneOf(objectValues(InputSize)),
  label: PT.node,
  hint: PT.node,
  error: PT.bool,
  value: PT.any,
  LabelProps: PT.exact(labelPropTypes),
  InputProps: PT.exact(inputPropTypes),
  inputProps: PT.object,
  inputRef: PT.oneOfType([PT.func, PT.object]),
  TextareaProps: PT.exact(textareaPropTypes),
  readOnly: PT.bool,
  disabled: PT.bool
};
export default InputGroup;